import { useEffect, useState } from 'react';
// eslint-disable-next-line import/named
import 'react-toastify/dist/ReactToastify.css';
import { Article, ArticleResponse } from '../services/coworkerApiCalls/Article/ArticlesTypes';
import { getArticleById, getArticles, getArticlesByCategory } from '../services/coworkerApiCalls/Article/Article';
import { articleResponseToArticle, articleResponsesToArticles } from '../services/helpers/ArticleMapper';
import { useOktaAuth } from '@okta/okta-react';

function useDataApiArticle(id: number) {
    const [article, setArticle] = useState<Article>();

    const { authState } = useOktaAuth();
    const token = authState!.idToken!.idToken

    useEffect(() => {
        const getUsers = async () => {

            const articleTemporary: Article = await getArticleById(token, id);
            const articleResult: ArticleResponse = articleResponseToArticle(articleTemporary);
            setArticle(articleResult);

        };
        void getUsers();

    }, [id, token]); // Or [] if effect doesn't need props or state
    
    return article;
}

function useDataApiArticles() {
    const [article, setArticle] = useState<Article[]>();

    const { authState } = useOktaAuth();
    const token = authState!.idToken!.idToken

    useEffect(() => {
        const getUsers = async () => {

            const articlesTemporary: Article[] = await getArticles(token);
            const articlesResult: ArticleResponse[] = articleResponsesToArticles(articlesTemporary);
            setArticle(articlesResult);

        };
        void getUsers();

    }, [token]); // Or [] if effect doesn't need props or state


    return article;
}

function useDataApiArticlesByCategory(categoryId:number) {
    const [article, setArticle] = useState<Article[]>();

    const { authState } = useOktaAuth();
    const token = authState!.idToken!.idToken

    useEffect(() => {
        const getUsers = async () => {

            const articlesTemporary: Article[] = await getArticlesByCategory(token, categoryId);
            const articlesResult: ArticleResponse[] = articleResponsesToArticles(articlesTemporary);
            setArticle(articlesResult);

        };
        void getUsers();

    }, [token, categoryId]); // Or [] if effect doesn't need props or state


    return article;
}


export { useDataApiArticle, useDataApiArticles, useDataApiArticlesByCategory }